 const baseUrl = 'http://localhost:4500';
module.exports = {baseUrl}